module.exports = __webpack_public_path__ + "static/media/microsoft_dark.4e1fdfee.svg";